import {ButtonGroup, Text} from '@/components-v2'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {useComboActions} from '@/hooks/productCombo/useComboActions'
import {useGetComboPromotion} from '@/hooks/productCombo/useGetComboPromotion'
import DeleteComboProductModal from '@/pages/ProductCombo/ComboDetail/DeleteComboModal'
import {convertISOToLocal} from '@/utility/dateHelper'
import {useState} from 'react'

export const PublishedComboHeader = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const {
    productCombo: {name, updatedDateTime, productId, isDraft},
  } = useProductCombo()
  const {duplicateProductCombo} = useComboActions()
  const publishedDateTime = convertISOToLocal(updatedDateTime)?.replace(', ', ' at ') || '-'
  const promotions = useGetComboPromotion(productId)
  const promotionsCount = promotions?.length

  const groupedButtons = [
    {
      label: 'Duplicate',
      onClick: () => duplicateProductCombo(),
    },
    {
      label: 'Delete',
      onClick: () => setModalOpen(true),
    },
  ]

  return (
    <>
      <h1 className="mb-4 text-xl font-bold">{name}</h1>
      <div className="flex items-center justify-between">
        <Text size="small" weight="medium">
          {!isDraft ? `Published on ${publishedDateTime}` : ''}
        </Text>
        <ButtonGroup items={groupedButtons} />

        <DeleteComboProductModal
          show={modalOpen}
          onClose={() => setModalOpen(false)}
          promotionNumber={promotionsCount}
          comboId={productId}
        />
      </div>
    </>
  )
}
